import Shape from './Shape';
import Coords from '../Util/Coords';

export default class SignalRing extends Shape {

    constructor(point, color) {
        super();
        this.step = 0;
        this.point = point;
        this.color = color;
    }

    alive() {
        this.step += 1;
        return this.step < 120;
    }

    draw(props) {
        let p = Coords.toView(this.point, props.viewCenter, props.lookingAt, props.tileSize);
        this.ctx.strokeStyle = this.color;
        this.ctx.lineWidth = 3;

        let radius = (Math.sin(-1.570796326794897 + (Math.PI * this.step/60)) + 1) * 50;

        this.ctx.beginPath();
        this.ctx.arc(p[0], p[1], radius, 0, 6.283185307179586);
        this.ctx.stroke();
    }

}